import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 -mt-0.5" }
const _hoisted_2 = {
  key: 0,
  class: "h-4 w-4 inline-block rounded border border-gray-300 bg-gray-100 cursor-not-allowed"
}
const _hoisted_3 = ["checked"]

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import {
  QueryValueAggregation,
  QueryValueReportConfig,
  QueryValueReportFilters,
} from "@/types/reports/PlotQueryValue";
import { previousPeriodForByMetric } from "@/views/reports/plots/query_value/queryValue";


export default /*#__PURE__*/_defineComponent({
  __name: 'QueryValueConfigFields',
  props: {
    config: {},
    filters: {},
    aggregation: {}
  },
  emits: ["configChange"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const handleShowPreviousPeriodChange = (event: Event) => {
  const inputElement = event.target as HTMLInputElement;
  emit("configChange", {
    ...props.config,
    show_previous_period: inputElement.checked,
  });
};

const isPreviousPeriodOptionAllowed = computed(() =>
  previousPeriodForByMetric[props.config.metric].includes(props.aggregation),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      class: _normalizeClass(["flex items-center w-fit", { 'cursor-pointer': isPreviousPeriodOptionAllowed.value }])
    }, [
      (!isPreviousPeriodOptionAllowed.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2))
        : (_openBlock(), _createElementBlock("input", {
            key: 1,
            type: "checkbox",
            class: "h-4 w-4 rounded border-gray-300 text-yellow-500 focus:ring-yellow-500 cursor-pointer",
            checked: _ctx.config.show_previous_period,
            onChange: handleShowPreviousPeriodChange
          }, null, 40, _hoisted_3)),
      _createElementVNode("span", {
        class: _normalizeClass(["ml-2", { 'text-gray-400': !isPreviousPeriodOptionAllowed.value }])
      }, _toDisplayString(_ctx.config.metric === "project_progress"
          ? _unref(t)("analytics.reports.show_planned_progress_value")
          : _unref(t)("analytics.reports.show_previous_period_value")), 3)
    ], 2)
  ]))
}
}

})